<template>
  <div>
        <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; width: 100%;">
            <div v-if="$store.getters.getCustomerPaymentList.length > 0 || $store.state.customerPayment.nav.had_results" style="display: flex; flex-direction: row; width: 100%; justify-content: space-between; align-items: space-between;">
                <SearchField v-if="!popup" :searchKeys="getResultKeys" @searchCustom="loadList"/>
                <span v-else>
                    <span v-html="'&nbsp;'"></span>
                </span>
                <el-button 
                    @click="createNew" 
                        v-if="$store.getters.getAccessRights.can_add 
                            && !readonly 
                                && (
                                    (source==='saleOrder' && $store.getters.getSaleMasterDataProps.balance>0) || source!=='saleOrder')" type="primary" size="small">Record New Receipt</el-button>
                
            </div>
            <div style="width: 100%;">
                <List 
                    @openPaymentForm="$emit('openPaymentForm')"
                    :popup="popup"
                    :source="source"
                    :readonly="readonly"
                    @closed="$emit('closed')"
                    :source_id="source_id"/>
            </div>
          
        </div>
      
  </div>
</template>

<script>
import List from './List'


export default {
    props: ['popup', 'source', 'source_id', 'readonly'],
    components: { List },
    computed: {
        getResultKeys() {
            return [
                {value: "t1.payment_date", label: "Payment Date", date_field: true}, 
                {value: "t1.payment_date_array", label: "Payment Date Range", date_range_field: true}, 
                {value: "t1.additional_notes", label: "Additional Notes"}, 
                {value: "t2.locality_name", label: "Locality Name", store_list: true}, 
                {value: "t4.company_name", label: "Company Name"}, 
                {value: "t4.customer_name", label: "Customer Name"}, 
                {value: "t5.mode_name", label: "Mode Name"},
                {value: "t6.sale_number", label: "Sale Number"},
                {value: "t6.external_number", label: "External Sale Number"}
            ]
        }
    },
    methods: {
        createNew() {
            this.$store.commit('resetCustomerPaymentData')
            if(this.popup) {
                if(this.checkIfModuleAccessAvailable('/customerpayment', 'can_add')) {
                    this.$emit('openPaymentForm')
                }
            } else {
                this.$router.push(this.$router.currentRoute.fullPath+'/form/')
            }
        },
        loadList($event) {
            this.$store.state.customerPayment.nav.search_term = $event.search_term
            this.$store.state.customerPayment.nav.total = 0
            this.$store.state.customerPayment.nav.page_number = 1
            this.$store.state.customerPayment.nav.search_term_array = $event.search_term_array
            this.$store.dispatch('fetchCustomerPaymentList', {store_list: this.$store.getters.getAccessibleStoreList, nav: this.$store.state.customerPayment.nav})    
        }
    },
    mounted() {
        
        if(this.$store.getters.getPaymentModeList.length === 0) {
            this.$store.dispatch('fetchPaymentModeList')
        }
        this.$store.commit('resetSaleMasterOutstandingList')
        setTimeout(() => {
            if(!this.popup) {
                this.loadList({search_term: this.$store.state.customerPayment.nav.search_term, search_term_array: this.$store.state.customerPayment.nav.search_term_array})
            } else {
                this.$store.dispatch('fetchCustomerPaymentList', {
                    store_list: [{store_id: 0}],
                    sale_id: this.$store.getters.getSaleMasterDataProps.id
                })  
            }
        }, 1000);
        
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/CustomerPayment/Index.vue